import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EquipmentSummaryComponent } from './equipment-summary';
import { EquipmentDetailComponent } from './equipment-detail';
import { EquipmentEditComponent } from './equipment-edit';
import { EquipmentCreateComponent } from './equipment-create';
import { Authguard } from '../../../helper';
import { Roles } from '../../../model';
import { EquipmentAssignFormComponent } from './equipment-assign-form/equipment-assign-form.component';
import { EquipmentCopyComponent } from './equipment-copy/equipment-copy.component';
import { EquipmentMigrateComponent } from './equipment-migrate/equipment-migrate.component';

const routes: Routes = [
  { path: '', redirectTo: 'summary', pathMatch: 'full' },
  {
    path: '',
    data: {
      title: 'Equipment'
    },
    children: [
      {
        path: 'summary',
        component: EquipmentSummaryComponent,
        data: { title: 'Summary' }
      },
      {  // for site specific summary (from site detail)
        path: 'summary-by-site/:siteId',
        component: EquipmentSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'summary-by-customer/:customerId',
        component: EquipmentSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'detail/:id',
        component: EquipmentDetailComponent,
        data: { title: 'Details' }
      },
      {
        path: 'edit/:id',
        component: EquipmentEditComponent,
        canActivate: [ Authguard ],
        data: {
          title: 'Edit' ,
          permission: {
            role: [Roles.Admin],
            redirectTo: '403'
          }
        }
      },
      {
        path: 'edit/form/:equipmentId',
        component: EquipmentAssignFormComponent,
        data: {
          title: 'Edit Default Form'
        }
      },
      {
        path: 'copy',
        component: EquipmentCopyComponent,
        data: { title: 'Copy' }
      },
      {
        path: 'migrate',
        component: EquipmentMigrateComponent,
        data: { title: 'Migrate' }
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EquipmentRoutingModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-routing.module.ts